import useLastDeployed from './useLastDeployed';
import useStatus from './useStatus';
import useDeployedRevisions from './useDeployedRevisions';
import useQueryCombinedPipeline from './useQueryCombinedPipeline';
import useCliManagedIntegrationJson from './useCliManagedIntegrationJson';

export default function useQueryPipelineWithRoost({ pipelineId, ...options }) {
  const { integrationsData, deployedPipeline, pipeline, loading, refetch } = useQueryCombinedPipeline({
    pipelineId,
    ...options,
  });

  const deployedRevisions = useDeployedRevisions({ pipeline, deployedPipeline, integrationsData });
  const status = useStatus({ pipeline, deployedPipeline, deployedRevisions });
  const lastDeployed = useLastDeployed({ deployedPipeline });
  const cliManagedIntegrationJson = useCliManagedIntegrationJson({ deployedRevisions });

  if (!pipeline || !integrationsData) {
    return {
      data: {
        legacy: {
          lastDeployed,
          status,
          deployedRevisions: [],
          pipelineIntegrations: [],
          cliManagedIntegrationJson: [],
        },
      },
      loading,
      refetch,
    };
  }

  return {
    data: {
      legacy: {
        ...pipeline,
        lastDeployed,
        status,
        deployedRevisions,
        deployedPipeline,
        cliManagedIntegrationJson,
      },
    },
    loading,
    refetch,
  };
}
